import type { InjectionKey } from "vue";
import type { QDialogOptions } from "quasar";
import { Dialog, useDialogPluginComponent } from "quasar";
import DialogComponent from "./Dialog.vue";
import DialogHeader from "./DialogHeader.vue";
import DialogBody from "./DialogBody.vue";
import DialogActions from "./DialogActions.vue";
import { disablePulldownToRefresh, enablePulldownToRefresh } from "@/stores/ui";

export const dialog = (options: QDialogOptions, clickEvent?: Event) => {
  if (options.component && clickEvent instanceof MouseEvent) {
    options.componentProps = {
      ...options.componentProps,
      transformOrigin: [clickEvent.clientX, clickEvent.clientY],
    };
  }
  disablePulldownToRefresh();
  return Dialog.create(options).onDismiss(enablePulldownToRefresh);
};

export const dialogInjectionKey = Symbol() as InjectionKey<
  Pick<
    ReturnType<useDialogPluginComponent>,
    "onDialogHide" | "onDialogCancel" | "onDialogOK"
  >
>;

export { DialogComponent as Dialog, DialogHeader, DialogBody, DialogActions };
